import { Component, inject } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { select, Store } from '@ngxs/store';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoginAction } from '../core/authentication/auth.state.model';
import { AuthModel } from '../core/authentication/auth.model';
import { AppSelectors } from '../app.state';

@Component({
  selector: 'pixl-login',
  imports: [
    MatCard,
    MatFormField,
    MatButton,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  store = inject(Store);
  fb = inject(FormBuilder);

  authState = select(AppSelectors.authState);

  authModel: AuthModel = {
    email: '',
    password: ''
  };

  loginForm = this.fb.group({
    email: [this.authModel.email, [Validators.required, Validators.email]],
    password: [this.authModel.password, [Validators.required]]
  });

  sendLogin() {
    if (this.loginForm.valid) {
      Object.assign(this.authModel, this.loginForm.value);
      this.store.dispatch(new LoginAction(this.authModel)).subscribe(() => {
        sessionStorage.setItem('isAuthenticated', 'true');
      });
    }
  }
}
